import * as React from 'react';
import { SelectCourseOption } from '../styles';
import { Paper } from '../studentForm';

export const DisplayPaper: React.FC<{
  paper: Paper;
  addToSelectedCourse: (paper: Paper) => void;
  reset: number;
}> = ({ paper, addToSelectedCourse, reset }) => {
  const [isSelected, setIsSelected] = React.useState(false);
  // reset
  React.useEffect(() => {
    setIsSelected(false);
  }, [reset]);
  return (
    <SelectCourseOption
      isChecked={isSelected}
      key={paper?._id}
      onClick={() => {
        if (paper) {
          addToSelectedCourse(paper);
          setIsSelected(!isSelected);
        }
      }}
    >
      <input
        type="checkbox"
        value={isSelected ? 'on' : 'off'}
        onChange={(e) => console.log(e.target.value)}
        checked={isSelected}
      />
      <h5>
        <b> {paper?.courseCode}, </b>
        {paper?.courseName} - {paper.class}
      </h5>
    </SelectCourseOption>
  );
};
